import api from './api';

export const METHOD_EMAIL = 'email';
export const METHOD_AUTHENTICATOR = 'authenticator';
export const METHOD_BOTH = 'both';

function authHeaders(accessToken) {
    return {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
    };
}

function normalizeMethod(value) {
    if (Array.isArray(value)) {
        const email = value.includes(METHOD_EMAIL);
        const authenticator = value.includes(METHOD_AUTHENTICATOR);
        if (email && authenticator) return METHOD_BOTH;
        if (authenticator) return METHOD_AUTHENTICATOR;
        return METHOD_EMAIL;
    }
    if (value === METHOD_AUTHENTICATOR) return METHOD_AUTHENTICATOR;
    if (value === METHOD_BOTH) return METHOD_BOTH;
    return METHOD_EMAIL;
}

function flag(value, fallback) {
    return typeof value === 'boolean' ? value : fallback;
}

export function normalizeCompanySecurity(raw) {
    const source = raw && typeof raw === 'object' ? raw : {};
    const limit = Number.parseInt(source.loginAttemptLimit, 10);
    const studentTwoFactorRequired = flag(
        source.studentTwoFactorRequired,
        flag(source.twoFactorRequired, false),
    );
    const studentTwoFactorMethod = normalizeMethod(
        source.studentTwoFactorMethod || source.twoFactorMethod,
    );
    const managerTwoFactorRequired = true;
    const managerTwoFactorMethod = normalizeMethod(source.managerTwoFactorMethod || METHOD_EMAIL);
    return {
        studentTwoFactorRequired,
        twoFactorRequired: studentTwoFactorRequired,
        studentTwoFactorMethod,
        twoFactorMethod: studentTwoFactorMethod,
        managerTwoFactorRequired,
        managerTwoFactorMethod,
        loginAttemptLimit: Number.isInteger(limit) && limit > 0 ? limit : null,
        emailLinkLogin: source.emailLinkLogin === true,
    };
}

export function companySecurityBody(input) {
    const normalized = normalizeCompanySecurity(input);
    return {
        studentTwoFactorRequired: normalized.studentTwoFactorRequired,
        studentTwoFactorMethod: normalized.studentTwoFactorMethod,
        managerTwoFactorRequired: normalized.managerTwoFactorRequired,
        managerTwoFactorMethod: normalized.managerTwoFactorMethod,
        loginAttemptLimit: normalized.loginAttemptLimit,
        emailLinkLogin: normalized.emailLinkLogin,
        twoFactorRequired: normalized.studentTwoFactorRequired,
        twoFactorMethod: normalized.studentTwoFactorMethod,
    };
}

export function securityToForm(raw) {
    const normalized = normalizeCompanySecurity(raw);
    return {
        studentTwoFactorRequired: normalized.studentTwoFactorRequired,
        twoFactorRequired: normalized.twoFactorRequired,
        studentTwoFactorMethod: normalized.studentTwoFactorMethod,
        twoFactorMethod: normalized.twoFactorMethod,
        managerTwoFactorRequired: normalized.managerTwoFactorRequired,
        managerTwoFactorMethod: normalized.managerTwoFactorMethod,
        emailLinkLogin: normalized.emailLinkLogin,
        loginAttemptLimit: normalized.loginAttemptLimit == null
            ? ''
            : String(normalized.loginAttemptLimit),
    };
}

export default {
    async get(accessToken) {
        const response = await api.get('/company/security', {
            headers: authHeaders(accessToken),
        });
        return normalizeCompanySecurity(response.data);
    },
    async update(accessToken, payload) {
        const response = await api.put('/company/security', companySecurityBody(payload), {
            headers: authHeaders(accessToken),
        });
        return normalizeCompanySecurity(response.data);
    },
    async getForCompany(accessToken, companyId) {
        const response = await api.get(`/admin/companies/${companyId}/security`, {
            headers: authHeaders(accessToken),
        });
        return normalizeCompanySecurity(response.data);
    },
    async updateForCompany(accessToken, companyId, payload) {
        const response = await api.put(
            `/admin/companies/${companyId}/security`,
            companySecurityBody(payload),
            { headers: authHeaders(accessToken) },
        );
        return normalizeCompanySecurity(response.data);
    },
};
